import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/admin-console/monitoring/')({
    beforeLoad: () => {
        throw redirect({ to: '/admin-console/monitoring/engagement', replace: true });
    },
});
